import { useMemo } from 'react'
import clsx from 'clsx'

import { formattValue } from 'shared/utils/currency'

import styles from './MinValueInfoBox.module.scss'

interface MissingValueInfoBoxProps {
  valueMissing: number | null
  type: 'delivery' | 'orderMissing'
}

const MissingValueInfoBox = ({
  valueMissing,
  type
}: MissingValueInfoBoxProps) => {
  const formattedMissingValue = useMemo(
    () => (valueMissing ? formattValue(valueMissing) : ''),
    [valueMissing]
  )
  const missingLabel = useMemo(() => {
    switch (type) {
      case 'delivery':
        return 'Do darmowej dostawy'
      case 'orderMissing':
        return 'Do minimalnej wartości koszyka'
    }
  }, [type])
  const ctaLabel = useMemo(() => {
    switch (type) {
      case 'delivery':
        return 'Dodaj produkty aby otrzymać darmową dostawę!'
      case 'orderMissing':
        return 'Dodaj produkty aby kontynuować zamówienie.'
    }
  }, [type])

  if (!valueMissing) {
    return null
  }

  return (
    <div
      className={clsx(styles.infoBoxWrapper, {
        [styles.infoBoxDelivery]: type === 'delivery'
      })}
    >
      {valueMissing > 0 && (
        <div className={styles.missingValueInfo}>
          {missingLabel} brakuje {formattedMissingValue}. {ctaLabel}
        </div>
      )}
    </div>
  )
}

export default MissingValueInfoBox
